import {
    createStore
} from 'vuex'

export default createStore({
    state: {
        operation: {}
    },
    mutations: {
        setOperation(state, data) {
            state.operation = data
        },
    },
    actions: {},
    modules: {}
})